var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.step === 1)?_c('ListStyleForm',{attrs:{"initdata":_vm.initData},on:{"next-step":_vm.nextStep,"prev-step":_vm.onClickPrev}}):_c('ListStyleResult',{attrs:{"initdata":_vm.resultData},on:{"next-step":_vm.nextStep,"prev-step":_vm.onClickPrev}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }